import crypto from "../util/crypto"
import auth from "../util/auth"
import sqlite from "../util/sqlite"
import Vue from 'vue'
import router from '../router'

export default {
    csrfToken: process.env.VUE_APP_CSRF_TOKEN,
    FileHost: process.env.VUE_APP_FILE_HOST + '/api',
    notSaveArray: ['SignIn'],
    appVersion: "", //用來存放目前app的版本號
    isDoAppUpdate: true,//用來判斷app更新詢問是否問過了(true:第一次訪問或重新訪問)
    initCsrfToken() {
        let req = new XMLHttpRequest();
        req.open('GET', document.location, false);
        req.send(null);
        let headers = req.getAllResponseHeaders().split('\n');
        headers.forEach(function (item) {
            if (item.indexOf('x-csrf-token') !== -1) {
                this.csrfToken = item.substring(item.indexOf(":") + 1);
                return false;
            }
        });``
    },
    //檢查當前在Line App開啟:true, 不是:false
    getLineAppOpen() {
        return navigator.userAgent.toLowerCase().includes("line");
    },
    getOS() {
        // eslint-disable-next-line no-prototype-builtins
        if(window.hasOwnProperty("cordova")){
            // eslint-disable-next-line no-console
            // console.log('getOS() => window.hasOwnProperty(cordova) = true');
        }

        let userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
          os = 'Mac OS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
          os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
          os = 'Windows';
        } else if (/Android/.test(userAgent)) {
          os = 'Android';
        } else if (!os && /Linux/.test(platform)) {
          os = 'Linux';
        }
        // eslint-disable-next-line no-console
        // console.log('getOS => os = ' + os);
        return os;
    },
    post(action, parameter, authPath, funcSuccess){
        // eslint-disable-next-line no-prototype-builtins
        if(window.hasOwnProperty("cordova")){
            sqlite.query('select json from offline_data where action like ?', [action], function(resultSet){
                let jsonStr = resultSet.rows.item(0).json;
                let json = JSON.parse(jsonStr);
                funcSuccess(json);
            });
        } else {
            this.send(action, parameter, authPath, funcSuccess);
        }
    },
    postWithAuthEncrypt() {  /* 需要驗證的api都必須呼叫此方法含加密 */
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? crypto.encryptText(JSON.stringify(args[2])) : crypto.encryptText(JSON.stringify(args[1]));
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.post(action, parameter, '/auth', funcSuccess);
    },
    postWithAuth() {  /* 需要驗證的api都必須呼叫此方法 */
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? JSON.stringify(args[2]) : JSON.stringify(args[1]);
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.post(action, parameter, '/auth', funcSuccess);
    },
    postWithEncrypt() { /* 整個參數json 轉成 string 再進行加密 */
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? crypto.encryptText(JSON.stringify(args[2])) : crypto.encryptText(JSON.stringify(args[1]));
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.post(action, parameter,'', funcSuccess);
    },
    fetchWithAuthEncrypt() {  /* 需要驗證的api都必須呼叫此方法含加密 */
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? crypto.encryptText(JSON.stringify(args[2])) : crypto.encryptText(JSON.stringify(args[1]));
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.send(action, parameter, '/auth', funcSuccess);
    },
    fetchWithAuth() {  /* 需要驗證的api都必須呼叫此方法 */
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? JSON.stringify(args[2]) : JSON.stringify(args[1]);
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.send(action, parameter, '/auth', funcSuccess);
    },
    fetchWithEncrypt() { /* 整個參數json 轉成 string 再進行加密 */
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? crypto.encryptText(JSON.stringify(args[2])) : crypto.encryptText(JSON.stringify(args[1]));
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.send(action, parameter,'', funcSuccess);
    },
    fetch() {
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? JSON.stringify(args[2]) : JSON.stringify(args[1]);
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.send(action, parameter,'', funcSuccess);
    },
    fetchShortUrlApiWithEncrypt() {
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? crypto.encryptText(JSON.stringify(args[2])) : crypto.encryptText(JSON.stringify(args[1]));
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.sendToShortUrlApi(action, parameter, funcSuccess);
    },
    async sendToShortUrlApi(action, parameter, funcSuccess) {
        await fetch(process.env.VUE_APP_SHORTURL_API_HOST, {
            body: JSON.stringify({
                'action': action,
                'parameters': parameter,
            }),
            headers: new Headers({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
            }),
            method: 'POST'
        }).then(response => {
            return response.text();
        }).then(text => {
            let json = JSON.parse(text.replace('while(1);', ''));
            funcSuccess(json);
        });
    },
    async send(action, parameter,authPath, funcSuccess) {
        const paramJsonStr = JSON.stringify({
            'action': action,
            'parameters': parameter,
        });

        let self = this;
        let appVersion = "";
        let os = this.getOS();
        if (os === "Mac OS" || os === "iOS" || os === "Android") {
            if (os === "Mac OS") {
                os = "iOS";
            }
        } else {
            os = "";
        }
        // eslint-disable-next-line no-prototype-builtins
        if (window.hasOwnProperty("cordova")) {
            await new Promise(resolve => {
                //取得裝置上目前App的版本 https://github.com/sampart/cordova-plugin-app-version
                window.cordova.getAppVersion.getVersionNumber().then(function (version) {
                    appVersion = version;
                    self.appVersion = appVersion;
                    resolve();
                });
            });
        }

        //印出送出的內容
        if(process.env.VUE_APP_MODE !== 'release') {
            let path = process.env.VUE_APP_API_HOST  + authPath;
            let headers = new Headers({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Csrf-Token': this.csrfToken === '' || typeof csrfToken === 'undefined' ? process.env.VUE_APP_CSRF_TOKEN : this.csrfToken,
                'Auth-Token': authPath === '/auth' ? auth.getAdminToken() : '',
                'appName': 'com.lifelink.oin',
                'App-Version': appVersion,
                'Device': os,
            });

            console.log('send path:' + path);
            headers.forEach((value, key, parent) => {
                console.log('send header:' +key + ',' +value + ',' + parent.toString());
            });

            console.log('send body:' + JSON.stringify(paramJsonStr));
        }

        //csrfToken : nF3mu/EOHGG7XfViQA+wXBj08T9iLhWuMZlkXm/r
        await fetch(process.env.VUE_APP_API_HOST  + authPath, {
            body: paramJsonStr,
            headers: new Headers({
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Csrf-Token': this.csrfToken === '' || typeof csrfToken === 'undefined' ? process.env.VUE_APP_CSRF_TOKEN : this.csrfToken,
                'Auth-Token': authPath === '/auth' ? auth.getAdminToken() : '',
                'appName': 'com.lifelink.oin',
                'App-Version': appVersion,
                'Device': os,
            }),
            method: 'POST'
        }).then(response => {
            return response.text();
        }).catch(() => {
            if(this.notSaveArray.indexOf(action) === -1 && this.method === 'post'){
                sqlite.insert("insert into upload_data(action, json) values (?, ?)", [action, paramJsonStr])
            }
        }).then(text => {

            //印出取得的內容
            if(process.env.VUE_APP_MODE !== 'release') {
                console.log('http result:' + text);
            }

            // JSON Hijacking while(1);
            let jsonStr = text.replace('while(1);', '');
            let json = JSON.parse(jsonStr);



            // sqlite.insert("insert into offline_data(action, json) values (?, ?)", [action, paramJsonStr])
            // if(this.notSaveArray.indexOf(action) === -1 && method === ''){
            //     sqlite.insert("insert delete api(action, json) values (?, ?)", [action, jsonStr])
            //     sqlite.insert("insert into api(action, json) values (?, ?)", [action, jsonStr])
            // }

            if (!json.status && (json.message === "logout" || json.message === "token is invalid")) {
                Vue.prototype.$auth.clearToken();
                router.push({path: '/'});
                return;
            }

            //判斷api回傳可更新app訊息
            if (json.status && json.message === "appUpdate") {
                // eslint-disable-next-line no-prototype-builtins
                if (window.hasOwnProperty("cordova")) {
                    if (this.isDoAppUpdate) {
                        let appUpdateInfo = json.data.appUpdateInfo;
                        let yes;
                        if (appUpdateInfo.isForce) {
                            alert(appUpdateInfo.appName + " 最新版本為 " + appUpdateInfo.version + "\n需立即更新才能繼續使用 " + appUpdateInfo.appName);
                            window.cordova.InAppBrowser.open(appUpdateInfo.url, "_system", "location=yes");
                            yes = true;
                        } else {
                            yes = confirm(appUpdateInfo.appName + " 最新版本為 " + appUpdateInfo.version + "\n按確定(OK)立即更新\n按取消(Cancel)下次啟動App再詢問");
                        }
                        if (yes) {
                            window.cordova.InAppBrowser.open(appUpdateInfo.url, "_system", "location=yes");
                        }
                        this.isDoAppUpdate = false;//讓app更新詢問終止重複訪問
                    }
                }
                let rs_json = json.data.rsJson;
                funcSuccess(rs_json);
            } else {
                funcSuccess(json);
            }
        });
    },

    /*
 ex: array file
    let imageAry = [];
    imageAry.push(this.logoImage);
    imageAry.push(this.logoImage);
    //按下確定後在＋
    this.$http.fetchUpload`${{
        "file":  imageAry,
        "folder":  "/test"
    }}
                    ${json => {
        console.log(json)
    }}`;

 ex: only file
     this.logoImage = file;
    //按下確定後在＋
    this.$http.fetchUpload`${{
        "file":   this.logoImage,
        "folder":  "/test"
    }}
    ${json => {
        console.log(json)
    }}`;
    */

    /** 上傳檔案的方法 */
    fetchFileUpload() {
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0] === '' ? args[1] : args[0][0];
        const parameter = args[0][0] === '' ? JSON.stringify(args[2]) : JSON.stringify(args[1]);
        const funcSuccess = args[0][0] === '' ? args[3] : args[2];
        this.fetchUpload();
    },
    async uploadSend(file, folder, funcSuccess, funcFail) {
        let data = new FormData();
        console.log(file)
        if (file[0] === undefined){
            data.append("file", file);
        }else {
            file.forEach(function(val) {
                data.append("file", val);
            })
        }
        data.append("folder", folder);
        data.append("apiKey", "41e1ac4a1ad16b11275cd9121b572225");
        await fetch(this.FileHost, {
            body:data,
            headers: new Headers({
                'Access-Control-Allow-Origin': '*',
            }),
            method: 'POST',

        }).then(response => {
            return response.text();
        }).then(text => {
            console.log(text)
            // JSON Hijacking while(1);
            let json = JSON.parse(text.replace('while(1);', ''));
            if (!json.status && json.message === "logout") {
                Vue.prototype.$auth.clearToken();
                router.push({path: '/'});
                return;
            }
            funcSuccess(json);
        }).catch(err=>{
            if(funcFail){
                funcFail(err);
            }
        });
    },
    async fetchUpload() {
        this.url = '';
        const args = Array.prototype.slice.call(arguments);
        const parameter = args[1];
        const funcSuccess = args[2];
        const funcFail = args[3];
        await this.uploadSend(parameter.file, parameter.folder, funcSuccess, funcFail);
    },

    /** 呼叫 app重新導向 api */
    fetchClickUrlApi() {
        const args = Array.prototype.slice.call(arguments);
        const action = args[0][0];
        const appName = args[1];
        const parameter = JSON.stringify(args[2]);
        const funcSuccess = args[3];
        this.sendAddUrlRecord(appName, action, parameter, funcSuccess);
    },
    async sendAddUrlRecord(appName, action, parameter, funcSuccess){

        const paramJsonStr = JSON.stringify({
            'action': action,
            'parameters': parameter,
        });

        //印出送出的內容
        if(process.env.VUE_APP_MODE !== 'release') {
            let path = process.env.VUE_APP_REDIRECT_API_HOST;
            let headers = new Headers({
                'Content-Type': 'application/json',
                'App-Name': appName,
            });

            console.log('ClickUrlApi send path:' + path);
            headers.forEach((value, key, parent) => {
                console.log('ClickUrlApi send header:' +key + ',' +value + ',' + parent.toString());
            });

            console.log('ClickUrlApi send body:' + JSON.stringify(paramJsonStr));
        }

        // if(process.env.NODE_ENV === "production"){
        await fetch(process.env.VUE_APP_REDIRECT_API_HOST, {
            body: paramJsonStr,
            headers: new Headers({
                'Content-Type': 'application/json',
                'App-Name': appName,
            }),
            method: 'POST'
        }).then(response => {
            return response.text();
        }).then( text => {
            //印出取得的內容
            if(process.env.VUE_APP_MODE !== 'release') {
                console.log('ClickUrlApi http result:' + text);
            }

            // JSON Hijacking while(1);
            let json = JSON.parse(text.replace('while(1);', ''));
            funcSuccess(json);
        });
        // }


    },
    browserOpenFeatures(obj = {isFooter: false}) {
        let params = ""
        // eslint-disable-next-line no-prototype-builtins
        if(window.hasOwnProperty("cordova")){
            if (this.getOS() === "Android") {
                if(obj.isFooter) {
                    params = ",footer=yes,footercolor=#343a40";
                } else {
                    params = ",footer=no";
                }
            }
        }

        return params
    },
}







